import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { ApolloProvider } from '@apollo/client';
import { Router, useHistory } from 'react-router-dom';
import { loadableReady } from '@loadable/component';
import { hot } from 'react-hot-loader/root';
import { ThemeProvider } from 'styled-components';
import { createBrowserHistory } from 'history';
import theme from '../theme';
import { init } from '../../shared/services/authService';
import client from './client.web';
import App from './App';
import './index.html';
import { Provider } from '../../shared/context/AppContext';
import config from './config';

const {
  logger: { sentry },
} = config;

Sentry.init(sentry);

const browserHistory = createBrowserHistory();

const Root = () => {
  const history = useHistory();
  const [token, setToken] = useState();

  useEffect(() => {
    (async () => {
      const authToken = await init({
        ensureLoggedIn: false,
        onRedirect: path => {
          history.push(path);
        },
      });
      setToken(authToken);
    })();
  }, []);

  return (
    <ApolloProvider client={client(token)}>
      <Provider mediaQueries={theme.mediaQueries} token={token}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </Provider>
    </ApolloProvider>
  );
};

const render = () =>
  (module.hot ? ReactDOM.render : ReactDOM.hydrate)(
    <Router history={browserHistory}>
      <Root />
    </Router>,
    document.getElementById('app')
  );

loadableReady(render);

export default hot(render);
